import React, { useState } from 'react';
import './Contact.css';

const FAQS = [
  { q: 'How do I receive the trading calls?', a: 'All calls are shared via our private Telegram channel. You also get WhatsApp updates for urgent trades. After payment, you\'ll be onboarded within 30 minutes.' },
  { q: 'What markets do you cover?', a: 'We cover Crypto (BTC, ETH, altcoins, futures) and the Indian Stock Market (NSE/BSE equities, F&O, intraday, swing & positional trades).' },
  { q: 'What is the accuracy rate of your calls?', a: 'Our historical accuracy is 85%+. Every call comes with defined entry, stop loss, and target. We also share the reasoning behind every trade.' },
  { q: 'Do I need prior experience to join?', a: 'Not at all! We have courses and plans for complete beginners. Our mentors guide you step by step. For live calls, basic market knowledge helps but isn\'t mandatory.' },
  { q: 'What payment methods are accepted?', a: 'We accept UPI (GPay, PhonePe, Paytm), NEFT/IMPS bank transfer, and other digital payments. Contact us on WhatsApp to get payment details.' },
  { q: 'Can I get a refund if unsatisfied?', a: 'We offer a 7-day satisfaction review. If you feel the service isn\'t what was promised, contact us and we\'ll work to resolve it. Detailed refund policy available on request.' },
];

const CONTACT_METHODS = [
  {
    icon: '💬',
    title: 'WhatsApp',
    desc: 'Fastest way to reach us',
    value: '+91 9926749937',
    link: 'https://wa.me/919926749937?text=Hi%20Kalpnic Trading!%20I%20have%20a%20question.',
    cta: 'Chat Now',
    color: '#25D366',
  },
  {
    icon: '✉️',
    title: 'Email',
    desc: 'For detailed enquiries',
    value: 'kalpnikacademy@gmail.com',
    link: 'mailto:kalpnikacademy@gmail.com',
    cta: 'Send Email',
    color: '#3b82f6',
  },
  {
    icon: '📱',
    title: 'Telegram',
    desc: 'Join our community',
    value: '@TradeEliteOfficial',
    link: 'https://t.me/TradeEliteOfficial',
    cta: 'Join Channel',
    color: '#0088cc',
  },
  {
    icon: '🕐',
    title: 'Support Hours',
    desc: 'We\'re available',
    value: 'Mon–Sat, 9AM–6PM IST',
    link: null,
    cta: null,
    color: '#f0b429',
  },
];

const Contact = () => {
  const [form, setForm] = useState({ name: '', phone: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const WHATSAPP_NUMBER = '919926749937';
  const [openFaq, setOpenFaq] = useState(null);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const msg = encodeURIComponent(
      `Hi Kalpnic Trading!\n\nName: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email}\nSubject: ${form.subject}\nMessage: ${form.message}`
    );
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`, '_blank');
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setForm({ name: '', phone: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="page-hero section-padding grid-bg">
        <div className="hero-glow-small" />
        <div className="container">
          <div className="tag">Get in Touch</div>
          <h1 className="section-title">We're Here to<br /><span className="gold-text">Help You Succeed</span></h1>
          <p className="section-subtitle">
            Have questions about our courses, plans, or just want to chat about trading?
            Reach out — we typically respond within 30 minutes!
          </p>
        </div>
      </section>

      {/* Contact Methods */}
      <section className="contact-methods section-padding">
        <div className="container">
          <div className="methods-grid">
            {CONTACT_METHODS.map((m, i) => (
              <div className="method-card card" key={i}>
                <span className="method-icon">{m.icon}</span>
                <h3>{m.title}</h3>
                <p className="method-desc">{m.desc}</p>
                <span className="method-value" style={{ color: m.color }}>{m.value}</span>
                {m.link && (
                  <a href={m.link} target="_blank" rel="noreferrer" className="method-btn btn-outline" style={{ borderColor: m.color, color: m.color }}>
                    {m.cta} →
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form + FAQ */}
      <section className="contact-main section-padding">
        <div className="container">
          <div className="contact-grid">
            {/* Form */}
            <div className="contact-form-wrap">
              <div className="tag">Send a Message</div>
              <h2 className="section-title">Drop Us a <span className="gold-text">Message</span></h2>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '32px', lineHeight: '1.6' }}>
                Fill the form below and it'll be sent directly to our WhatsApp for the fastest response.
              </p>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Your Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="Rahul Sharma"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input
                      type="tel"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="+91 99999 99999"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="rahul@example.com"
                  />
                </div>
                <div className="form-group">
                  <label>Subject *</label>
                  <select name="subject" value={form.subject} onChange={handleChange} required>
                    <option value="">Select a subject...</option>
                    <option value="Course Enquiry">Course Enquiry</option>
                    <option value="Subscription Plan">Subscription Plan</option>
                    <option value="Investment Plan">Investment Plan</option>
                    <option value="Mentoring Session">Mentoring Session</option>
                    <option value="General Question">General Question</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Message *</label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Tell us how we can help you..."
                    rows={5}
                    required
                  />
                </div>
                <button type="submit" className="btn-gold submit-btn">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Send via WhatsApp
                </button>
                {submitted && (
                  <div className="submit-success">
                    ✅ Message sent! We'll respond within 30 minutes.
                  </div>
                )}
              </form>
            </div>

            {/* FAQ */}
            <div className="faq-wrap">
              <div className="tag">FAQ</div>
              <h2 className="section-title">Common <span className="gold-text">Questions</span></h2>
              <div className="faq-list">
                {FAQS.map((faq, i) => (
                  <div
                    className={`faq-item ${openFaq === i ? 'open' : ''}`}
                    key={i}
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  >
                    <div className="faq-question">
                      <span>{faq.q}</span>
                      <span className="faq-icon">{openFaq === i ? '−' : '+'}</span>
                    </div>
                    {openFaq === i && (
                      <div className="faq-answer">{faq.a}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp CTA */}
      <section className="whatsapp-cta section-padding">
        <div className="container">
          <div className="wa-cta-inner">
            <div className="wa-icon-big">
              <svg viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </div>
            <div className="wa-cta-text">
              <h2 className="section-title">Prefer to Chat <span className="gold-text">Directly?</span></h2>
              <p>We're active on WhatsApp every day. Ask us anything about trading, courses, or plans — we love talking markets!</p>
            </div>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Hi Kalpnic Trading! I want to learn more about your services.')}`}
              target="_blank"
              rel="noreferrer"
              className="btn-gold wa-cta-btn"
            >
              Open WhatsApp Chat
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
